import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {NgClass, NgIf} from '@angular/common';

@Component({
  selector: 'app-password-strength',
  standalone: true,
  imports: [NgClass, NgIf],
  templateUrl: './password-strength.component.html',
  styleUrl: './password-strength.component.scss'
})
export class PasswordStrengthComponent implements OnChanges {
  @Input() password: string = '';

  // Individual criteria checks
  hasMinLength: boolean = false;
  hasMaxLength: boolean = true;
  hasLetter: boolean = false;
  hasNumber: boolean = false;
  hasSpecialChar: boolean = false;

  // Overall strength (0-4 based on criteria met)
  strength: number = 0;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['password']) {
      this.checkPassword();
    }
  }

  private checkPassword(): void {
    const password = this.password || '';

    // Check each criteria
    this.hasMinLength = password.length >= 8;
    this.hasMaxLength = password.length <= 20;
    this.hasLetter = /[a-zA-Z]/.test(password);
    this.hasNumber = /[0-9]/.test(password);
    this.hasSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password);

    // Calculate strength (0-4)
    this.strength = 0;
    if (this.hasMinLength && this.hasMaxLength) this.strength++;
    if (this.hasLetter) this.strength++;
    if (this.hasNumber) this.strength++;
    if (this.hasSpecialChar) this.strength++;
  }

  get strengthPercentage(): number {
    return (this.strength / 4) * 100;
  }

  get strengthColor(): string {
    if (this.strength === 0) return 'bg-gray-200';
    if (this.strength === 1) return 'bg-red-500';
    if (this.strength === 2) return 'bg-orange-500';
    if (this.strength === 3) return 'bg-yellow-500';
    return 'bg-green-500'; // strength === 4
  }

  get isComplete(): boolean {
    return this.strength === 4;
  }
}
